import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

interface LoadingScreenProps {
  message?: string;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ message = 'Loading...' }) => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'background.default',
        zIndex: 9999,
      }}
      className="cad-grid-bg"
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 3,
        }}
        className="slide-up"
      >
        <Typography
          variant="h2"
          component="h1"
          color="primary"
          sx={{ fontWeight: 'bold', mb: 2 }}
        >
          PARAGON LIVE DESIGN
        </Typography>
        
        <CircularProgress
          size={60}
          thickness={4}
          color="primary"
          className="pulse"
        />
        
        <Typography
          variant="h6"
          color="text.secondary"
          sx={{ mt: 2 }}
        >
          {message}
        </Typography>
      </Box>
    </Box>
  );
};

export default LoadingScreen; 